import React from "react";
import { ModeRendererProps } from "./types";

export function IsoMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#iso)" />
      <g transform="translate(397 540)">
        {Array.from({ length: 9 }).map((_, i) => (
          <g key={i} transform={`scale(${1 + i * 0.09})`} opacity={0.4 - i * 0.03}>
            <polygon
              points="0,-90 78,-45 78,45 0,90 -78,45 -78,-45"
              fill="none"
              stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              strokeWidth="2"
            />
            <line x1="0" y1="-90" x2="0" y2="90" stroke={brand.white} strokeOpacity="0.2" />
            <line x1="-78" y1="-45" x2="78" y2="-45" stroke={brand.white} strokeOpacity="0.2" />
            <line x1="-78" y1="45" x2="78" y2="45" stroke={brand.white} strokeOpacity="0.2" />
          </g>
        ))}
      </g>
    </g>
  );
}
